//src/components/homeSolutionsData.js
import DigitalOutreachImg from '../assets/attract_more_patient.jpg';
import DataAndInsights from '../assets/get_deeper_insights.jpg';
import BillingAndPayments from '../assets/get_paid_faster.jpg';
import EMR from '../assets/Manage_records_digitally.jpg';
import WebsiteVisitors from '../assets/Website-visitors.png';

const homeSolutionsData = [
    {
        id: 1,
        title: "EMR",
        text: "Experience a modern, certified EHR solution that encompasses everything your practice requires, from robust charting and streamlined documentation to comprehensive patient histories, eRx, eLabs, and telehealth. Gain control over how you deliver care.",
        image: EMR,
        buttonLabel: "Learn more",
        link: "/emr",
    },
    {
        id: 2,
        title: "Digital Footprint",
        text: "Expand your practice with secure & customizable websites, rank on search engines with our search engine optimization experts. search marketing tools, automated reputation management, polished web profiles, and effective social media management.",
        image: WebsiteVisitors,
        buttonLabel: "Learn more",
        link: "/digital-footprint",
    },
    {
        id: 3,
        title: "Digital Outreach",       
        text: "Expand your reach and grow your practice with powerful search marketing tools, seamless automated reputation management systems, professionally polished web profiles, and highly effective social media management strategies designed to attract and engage patients.",
        image: DigitalOutreachImg,
        buttonLabel: "Learn more",
        link: "digital-outreach",
    },
    {
        id: 4,
        title: "Billing & Payments",
        text: "Enroll, submit, track within a unified platform. Reporting and analytics provide comprehensive visibility into your financial health, while intelligent automation tools and streamlined payment methods guarantee faster and more efficient collection processes.",
        image: BillingAndPayments,
        buttonLabel: "Learn more",
        link: "billing-and-payments",
    },
    {
        id: 5,
        title: "Data & Insights",
        text: "Gain deeper insights into your practice's growth and patient revenue with Doclivo's advanced analytics platform, offering real-time data tracking, comprehensive reporting, and actionable insights to optimize performance and drive informed decision-making for your practice.",
        image: DataAndInsights,
        buttonLabel: "Learn more",
        link: "data-and-insights",
    },
   
    // Add more items as needed

];

export default homeSolutionsData;